
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '../bootstrap';
import '../plugins';
const Swal = require('sweetalert2')
window.Swal = Swal;
 
import Vue from 'vue';
import * as AutoKana from 'vanilla-autokana'
import Vuelidate from 'vuelidate'
import Select2 from "v-select2-component"

Vue.use(Vuelidate)

window.Vue = Vue;
window.AutoKana = AutoKana;

require('../vendor/autokana.js');
require('./plugins/main.js');
require('./plugins/autokana.js');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('payment-update', require('./components/Payment/Payment.vue').default);
Vue.component('register-estimate', require('./components/RegisterEstimate/RegisterEstimate.vue').default);
Vue.component("Select2", Select2);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
